import { action } from 'easy-peasy';
import { IActionHide } from '~/store/snackbar/types';

const hideSnackbar: IActionHide = action(state => {
  state.message = null;
  state.isError = false;
});

export default hideSnackbar;
